// extracted by mini-css-extract-plugin
export default {"mainBody":"index_mainBody_RUqSP","cmt_past":"index_cmt_past_EnFYf clearfix","cmtBox":"index_cmtBox_JWdrO","footer":"index_footer_2LLel"};